import styled from 'styled-components'
import {ColumnFlexContainer} from '../../../../styledComponents/FlexComponents'
import {Colors, FontSize, FontWeights} from '../../../../styledComponents/Constants'
import React, {ReactNode} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faExternalLinkAlt, faFileAlt,
    faFileCsv,
    faFileExcel,
    faFilePdf,
    faFilePowerpoint,
    faFileWord
} from '@fortawesome/free-solid-svg-icons'
import {faImage} from '@fortawesome/free-regular-svg-icons'
import {UnstyledLinkStyledButton} from '../../../../styledComponents/Button'
import {StyledHR} from '../../../../styledComponents/StyledTypeDefinitions'

export function getLinkIconComponent(linkFileExtension: string = 'NONE'): ReactNode {
    switch (linkFileExtension.toUpperCase()) {
        case 'DOCX':
            return <FontAwesomeIcon icon={faFileWord}/>
        case 'XLSX':
            return <FontAwesomeIcon icon={faFileExcel}/>
        case 'PPTX':
            return <FontAwesomeIcon icon={faFilePowerpoint}/>
        case 'PDF':
            return <FontAwesomeIcon icon={faFilePdf}/>
        case 'CSV':
            return <FontAwesomeIcon icon={faFileCsv}/>
        case 'JPG':
        case 'JPEG':
        case 'PNG':
        case 'GIF':
            return <FontAwesomeIcon icon={faImage}/>
        case 'NONE':
            return <FontAwesomeIcon icon={faExternalLinkAlt}/>
        default:
            return <FontAwesomeIcon icon={faFileAlt}/>
    }
}

export const DialogCloseButton = styled(UnstyledLinkStyledButton)`
  height: 44px;
  width: 44px;
  color: ${Colors.AccentDark};
`

export const DisplayItemDividerDialog: StyledHR = styled.hr`
  border: none;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid ${Colors.AccentLight};
`

export const DialogTitleArea = styled.div`
  margin: 10px;
`

export const PanelArea = styled(ColumnFlexContainer)`
  height: 100%;
  align-items: stretch;
  padding-bottom: 30px;
  overflow-wrap: anywhere;
`

export const MainArea = styled.div`
  margin: 0 15px;
`

export const FacilityName = styled.div`
  font-size: ${FontSize.Body};
  line-height: 1.25;
  font-weight: ${FontWeights.Bold};
  color: ${Colors.Body};
`

export const DialogTitle = styled.div`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
  margin-left: 5px;
`